var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('div',[_c('span',{staticClass:"copyright-text",domProps:{"innerHTML":_vm._s((_vm.$mq.resize && _vm.$mq.below('768px')) ? _vm.mobileText:_vm.text)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e78b4c8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 